import Typography from "@mui/material/Typography";
import {Avatar, Stack} from "@mui/material";
import thousandSeparator from "../../../utils/numberUtils";
import IconButton from "@mui/material/IconButton";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import Button from "@mui/material/Button";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DinoDialog from "../../../components/Dialog";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import {useContext, useRef, useState} from "react";
import {useParams} from "react-router";
import PriceData from "./PriceData";
import ConfigContext from "../../../context/ConfigContext";
import Loading from "../../../components/Loading";
import usePriceQueries from "../../../hooks/queries/usePriceQueries";
import useServiceQueries from "../../../hooks/queries/useServiceQueries";
import DisabledWrapper from "../../../components/DisabledWrapper";

const Services = () => {
    const editPriceForm = useRef(null)
    const newPriceForm = useRef(null)
    const params = useParams()
    const [current, setCurrent] = useState(-1)
    const [priceDeleteDialog, setPriceDeleteDialog] = useState(false)
    const [priceEditDialog, setPriceEditDialog] = useState(false)
    const [priceDialog, setPriceDialog] = useState(false)
    const {baseUrl} = useContext(ConfigContext)
    let selectableServices = []

    const {usePriceColleagueQuery, createPriceMutation, updatePriceMutation, deletePriceMutation} = usePriceQueries()
    const {serviceBusinessQuery} = useServiceQueries()
    const {data: prices, isPending: pricesLoading} = usePriceColleagueQuery(params.colleagueId)
    const {data: services, isPending: servicesLoading} = serviceBusinessQuery


    const newPrice = data => {
        setPriceDialog(false)
        createPriceMutation.mutate({...data, colleague: params.colleagueId})
    }

    const editPrice = data => {
        setPriceEditDialog(false)
        updatePriceMutation.mutate({id: current, data})
    }

    const removePrice = () => {
        setPriceDeleteDialog(false)
        deletePriceMutation.mutate(current)
    }

    const findPrice = id => prices.find(p => p.id === id)

    const findService = id => services.find(s => s.id === id)

    if (pricesLoading || servicesLoading) return <Loading isLoading />

    const usedServices = prices?.map(p => p.service)
    selectableServices = services.filter(s => !usedServices.includes(s.id))

    return <div className="white-card">
        <Typography variant='subtitle1'>Szolgáltatások</Typography>
        <Typography variant='body2' color='#536B74'>Add meg kolléga által nyújtott
            szolgáltatásokat!</Typography>
        <Stack spacing={2} marginTop={2}>
            {prices?.map((p, i) => <Stack direction='row' key={`price_${i}`}
                                         justifyContent="space-between">
                <Stack direction='row' spacing={2} alignItems='center'>
                    <Avatar src={baseUrl + findService(p?.service)?.image}
                            sx={{width: '48px', height: '48px'}}/>
                    <Stack>
                        <Typography variant='subtitle2'>{findService(p?.service)?.name}</Typography>
                        <Typography variant='caption'
                                    color='#536B74'>{findService(p?.service)?.length} perc</Typography>
                    </Stack>
                </Stack>
                <Stack direction={{xs: 'column', md: 'row'}} spacing={1} alignItems='center'>
                    <Typography
                        variant='caption'
                        color='#2F5C43'>
                        {thousandSeparator(p.price)} Ft
                    </Typography>
                    <Stack direction='row' spacing={1}>
                        <IconButton onClick={() => {
                            setCurrent(p.id)
                            setPriceEditDialog(true)
                        }} sx={{
                            border: '2px solid',
                            borderColor: 'primary.main',
                            background: '#fff',
                            color: 'primary.main'
                        }}>
                            <ModeEditOutlineRoundedIcon/>
                        </IconButton>
                        <IconButton onClick={() => {
                            setCurrent(p.id)
                            setPriceDeleteDialog(true)
                        }} sx={{
                            border: '2px solid',
                            borderColor: 'primary.main',
                            background: '#fff',
                            color: 'primary.main'
                        }}>
                            <DeleteRoundedIcon/>
                        </IconButton>
                    </Stack>
                </Stack>
            </Stack>)}
        </Stack>
        <Stack direction={{xs: 'column', sx: 'row', md: 'row'}} marginTop={2} spacing={2}>
            <DisabledWrapper disabledCause={[{disabled: selectableServices.length === 0, message: 'Nincs több szolgáltatásod!'}]}>
                <Button
                    variant='contained'
                    onClick={() => setPriceDialog(true)}
                    sx={{alignSelf: 'end'}}
                    endIcon={<AddCircleIcon/>}
                >
                    Új szolgáltatás hozzáadása
                </Button>
            </DisabledWrapper>
        </Stack>

        <DinoDialog open={priceDeleteDialog}
                    title='Ár törlése'
                    subtitle='Ha kitörlöd az árat a kliensek számára nem fog megjelenni a foglalási folyamat során!'
                    handleClose={() => setPriceDeleteDialog(false)}>
            <Stack direction='row' justifyContent='end' spacing={1} marginTop={3}>
                <Button variant='outlined' onClick={() => setPriceDeleteDialog(false)}>Mégsem</Button>
                <Button variant='contained' onClick={removePrice} endIcon={<DeleteRoundedIcon/>}>Törlés</Button>
            </Stack>
        </DinoDialog>

        <DinoDialog open={priceEditDialog}
                    title='Ár szerkesztése'
                    subtitle='Add meg az új árat!'
                    handleClose={() => setPriceEditDialog(false)}>
            <PriceData reference={editPriceForm} data={findPrice(current)} prices={prices} handleSubmit={editPrice}/>
            <Stack direction='row' justifyContent='end' spacing={1} marginTop={3}>
                <Button variant='outlined' onClick={() => setPriceEditDialog(false)}>Mégsem</Button>
                <Button variant='contained' onClick={() => editPriceForm.current.requestSubmit()} endIcon={<SaveRoundedIcon/>}>
                    Változtatások mentése
                </Button>
            </Stack>
        </DinoDialog>

        <DinoDialog open={priceDialog}
                    title='Új szolgáltatás hozzárendelése'
                    subtitle='Add meg az új árat!'
                    handleClose={() => setPriceDialog(false)}>
            <PriceData reference={newPriceForm} prices={prices} handleSubmit={newPrice}/>
            <Stack direction='row' justifyContent='end' spacing={1} marginTop={3}>
                <Button variant='outlined' onClick={() => setPriceDialog(false)}>Mégsem</Button>
                <Button variant='contained' onClick={() => newPriceForm.current.requestSubmit()} endIcon={<SaveRoundedIcon/>}>
                    Változtatások mentése
                </Button>
            </Stack>
        </DinoDialog>
    </div>
}

export default Services